import { useCallback } from 'react';
import { read } from 'xlsx';

export const useFiles = ({
  currentModelSettings,
  setSheets,
  setSheetNames,
  setIsFileReadyforValidate,
  setFile,
  formik,
}: any) => {
  const handleDownload = () => {
    const downloadTemplate = currentModelSettings.fileTemplateToDownload;

    if (!downloadTemplate) {
      console.error('No file template provided for download.');
      return;
    }

    const isUrl =
      downloadTemplate.startsWith('http://') ||
      downloadTemplate.startsWith('https://');

    if (isUrl) {
      const alink = document.createElement('a');
      alink.href = downloadTemplate;
      alink.download = '';
      alink.target = '_blank';
      alink.click();
    } else {
      fetch(downloadTemplate)
        .then((response) => {
          if (!response.ok) {
            throw new Error(`Failed to fetch file: ${response.statusText}`);
          }
          return response.blob();
        })
        .then((blob) => {
          const fileURL = window.URL.createObjectURL(blob);

          const alink = document.createElement('a');
          alink.href = fileURL;
          alink.download = downloadTemplate;
          alink.click();

          window.URL.revokeObjectURL(fileURL);
        })
        .catch((error) => {
          console.error('Error downloading file:', error);
        });
    }
  };

  const processFile = useCallback(
    (file: File) => {
      const reader = new FileReader();

      reader.onload = (event: ProgressEvent<FileReader>) => {
        const data = event.target?.result;
        if (data) {
          const workbook = read(data, { type: 'binary' });
          const sheets = workbook.Sheets;
          const sheetNames = workbook.SheetNames;
          setSheets((prevState: any[]) => prevState.concat(sheets));
          setSheetNames((prevState: string[]) => prevState.concat(sheetNames));
          setIsFileReadyforValidate(true);
        }
      };

      reader.readAsBinaryString(file);
    },
    [setIsFileReadyforValidate, setSheetNames, setSheets],
  );

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const target = event.target || null;
    setFile(target.files);
    formik.setFieldValue('file', target.files);
  };

  const generateOutputFile = (response: {
    data: { data: { file: string } };
  }) => {
    const binaryString = response.data.data.file
      .split('')
      .map((char: string) => char.charCodeAt(0));
    const byteArray = new Uint8Array(binaryString);

    const blob = new Blob([byteArray], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    return window.URL.createObjectURL(blob);
  };

  return {
    generateOutputFile,
    handleFileChange,
    processFile,
    handleDownload,
  };
};
